import { Injectable } from "@angular/core";
// import { GraphQLResult, generateClient } from 'aws-amplify/api';

// import { graphqlOperation } from '@aws-amplify/api-graphql';
import { InputVendorDetails, VendorModel } from "../../model/vendor.modal";
import {
  countriesDataQueries,
  createVendorQueries,
  findVendorQueries,
  getVendorQueries,
  updateVendorQueries,
} from "../../graphql/vendor.queries";
import { AppConstants } from "./app-constants";
import { environment } from "../../../../../../environments/environment";
import { MiscDataModel } from "../../model/miscData.model";
import { HttpClient } from "@angular/common/http";
// const client = generateClient();

import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "aws-amplify/lib/API/types";
import { TableConstants } from "../../../../../constants/table-constants";
import { HttpUtilsService } from "../../../../../service/httputils.service";

//const client = generateClient();

let myAppConfig = environment.myAppConfig;

let url = environment.pg_dburl[window.location.origin];

Amplify.configure(myAppConfig);

@Injectable({
  providedIn: "root",
})
export class VendorService {
  created_date: string;
  updated_date: string;
  constructor(private httpUtils: HttpUtilsService) {
    this.created_date = this.localDateFormate();
    this.updated_date = this.localDateFormate();
  }

  localDateFormate() {
    // Assuming mydate is defined as a Date object
    const mydate = new Date();

    // Convert the date to ISO 8601 format including the local time zone offset
    const isoDateString = mydate.toISOString();

    // Alternatively, you can manually format the date string to include the local time zone offset
    const offset = -mydate.getTimezoneOffset(); // Get the offset in minutes
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;
    const offsetSign = offset >= 0 ? "+" : "-";

    const formattedDateString = `${mydate.getFullYear()}-${this.padZero(
      mydate.getMonth() + 1
    )}-${this.padZero(mydate.getDate())}T${this.padZero(
      mydate.getHours()
    )}:${this.padZero(mydate.getMinutes())}:${this.padZero(
      mydate.getSeconds()
    )}${offsetSign}${this.padZero(offsetHours)}:${this.padZero(offsetMinutes)}`;
    console.log(formattedDateString); // Output: 2024-02-14T15:02:01+05:30
    return formattedDateString;
  }

  padZero(num: number): string {
    return num < 10 ? "0" + num : num.toString();
  }

  private QUERY_KEY = {
    LIST: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVendorDetail}`,
    GET: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.listCpVendorDetail}`,
    CREATE_OR_UPDATE: `${AppConstants.create}${environment.dbPrefix}${AppConstants.createOrUpdateCpVendorDetail}`,
    list_MiscData: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listMiscData}`,
  };

  public async filterByVendor(vendorType: string): Promise<VendorModel[]> {
    const tablename = TableConstants.CpVendorDetail;
    const endpoint = `${url}/${tablename}?data->>vendor_type=eq.${vendorType}`;
    try {
      const response = await this.httpUtils.get<VendorModel[]>(endpoint);
      if (response) {
        console.log("[VENDOR_RESPONSE]", response);
        return response;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching vendor request status:", error);
      throw error;
    }
  }

  public async getCountry(key: string): Promise<MiscDataModel[]> {
    const tablename = TableConstants.MiscData;
    const endpoint = `${url}/${tablename}?data->>data_key=eq.${key}`;
    try {
      const response = await this.httpUtils.get<MiscDataModel[]>(endpoint);
      if (response) {
        console.log("[GET_COUNTRY_RESPONSE]", response);
        return response;
      } else {
        throw new Error("REST operation returned no data in misc data.");
      }
    } catch (error) {
      console.error("Error fetching misc request status:", error);
      throw error;
    }
  }

  public async createVendor(createdObj: any): Promise<InputVendorDetails> {
    const tablename = TableConstants.CpVendorDetail;
    const endpoint = `${url}/${tablename}?select=*`;
    const payload = {
      name: createdObj.name,
      email: createdObj.email,
      phone: createdObj.phone,
      address: createdObj.address,
      vendor_type: createdObj.vendor_type,
      is_active: createdObj.is_active,
      ex_data: createdObj.ex_data,
      created_date: this.localDateFormate(),
      updated_date: this.localDateFormate(),
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0].id
        : null;
    } catch (error) {
      console.error("Error creating vendor:", error);
      throw error;
    }
  }

  public async updateVendor(
    updateObj: any
  ): Promise<InputVendorDetails | null> {
    const functionName = TableConstants.fnUpdateVendor;
    const endpoint = `${url}/${functionName}?select=*`;
    const payload = {
      p_id: updateObj.id,
      updates: {
        name: updateObj.name,
        email: updateObj.email,
        phone: updateObj.phone,
        address: updateObj.address,
        vendor_type: updateObj.vendor_type,
        is_active: updateObj.is_active,
        ex_data: updateObj.ex_data,
        updated_date: this.localDateFormate(),
      },
      p_updated_date: this.localDateFormate(),
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error updating vendor:", error);
      throw error;
    }
  }
  public async getVendorListService(): Promise<VendorModel[]> {
    const tablename = TableConstants.CpVendorDetail; // or use TableConstants.CpVendorDetail if defined
    const endpoint = `${url}/${tablename}`;
    try {
      const response = await this.httpUtils.get<VendorModel[]>(endpoint);
      if (response) {
        console.log("[VENDOR_RESPONSE]", response);
        return response;
      } else {
        throw new Error("REST operation returned no data vendor list.");
      }
    } catch (error) {
      console.error("Error fetching vendor list request status:", error);
      throw error;
    }
  }
}
